import { render, staticRenderFns } from "./LottoBall.vue?vue&type=template&id=313017a1&scoped=true&"
import script from "./LottoBall.vue?vue&type=script&lang=js&"
export * from "./LottoBall.vue?vue&type=script&lang=js&"
import style0 from "./LottoBall.vue?vue&type=style&index=0&id=313017a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313017a1",
  null
  
)

export default component.exports